import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {Formik} from 'formik'
import _ from 'lodash'
import React, {useContext, useMemo} from 'react'
import CustomRichEditor from 'views/AppLocals/custom/CustomRichEditor'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {convertFromString, convertToString} from 'views/SlateEditor/functions'
import {CourseActionTypes} from '..'
import CourseContext from '../CourseContext'

const formSchema = {
  about: {
    title: 'about course',
    children: [
      {
        name: 'about',
        component: ({ name, value, form, onChange }) => {
          const { resetKey } = form?.values ?? {}
          return (
            <CustomRichEditor
              {...{
                name,
                value,
                resetKey,
                onChange,
              }}
              placeholder="about course"
            />
          )
        },
      },
    ],
  },
}

const CourseSettingAbout = () => {
  const { item, updateAsync, handleAction = NullAsDefault } = useContext(CourseContext)

  const { isLoading } = updateAsync ?? {}

  const initialValues = useMemo(() => {
    const { about, ...rest } = item ?? {}
    return {
      ...rest,
      about: convertFromString(about),
    }
  }, [item])

  const handleSubmit = (values) => {
    handleAction(CourseActionTypes.COURSE_UPDATE, values)
  }

  return (
    <div className="flex flex-col gap-3">
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={(values) => {
          const changes = shallowDiff(values, initialValues)
          const { about, resetKey, ...rest } = changes ?? {}
          handleSubmit(
            _.omitBy(
              {
                ...rest,
                about: about ? convertToString(about) : undefined,
              },
              _.isUndefined
            )
          )
        }}>
        <React.Fragment>
          <FieldsFactory formSchema={[formSchema.about]} />
          <FormActionGroups
            isSubmitting={isLoading}
            submitProps={{
              label: 'save',
            }}
          />
        </React.Fragment>
      </Formik>
    </div>
  )
}

export default CourseSettingAbout
